import WebServiceRequestForBlog from "@/libs/Api/WebServiceRequestForBlog";

class GetAllBlogCategories extends WebServiceRequestForBlog {
  constructor(context) {
    super(context);
    super.setMethod("GET");
    super.setTag("BlogCategories/GetAllByFilter");
  }
  setParams(params){
      super.setRequestParam(params);
  }
}

class CreateBlogCategory extends WebServiceRequestForBlog {
  constructor(context) {
    super(context);
    super.setMethod("POST");
    super.setTag("BlogCategories/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class UpdateABlogCategory extends WebServiceRequestForBlog {
  constructor(context) {
    super(context);
    super.setMethod("PUT");
    super.setTag("BlogCategories/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}
class DeleteBlogCategory extends WebServiceRequestForBlog {
    constructor(context) {
        super(context);
        super.setMethod("DELETE");
    }
    setParams(id) {
        super.setTag(`BlogCategories/Delete/${id}`);
    }
}


export { GetAllBlogCategories, CreateBlogCategory, UpdateABlogCategory ,DeleteBlogCategory};
